import React from 'react';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import FilterMenu from '../FilterMenu';
import SearchResult from '../SearchResult';
import { Box } from '@material-ui/core';
import { Helmet } from "react-helmet";

const useStyles = makeStyles((theme) => ({
  root: {
    width: isMobile ? 375 : 1500,
    height: isMobile ? 'auto' : '1489px',
    minHeight:  isMobile ? 4100: 1489,
    paddingLeft: 0,
    backgroundColor: '#E3EFFE',
  },
  rootgrid: {
    flexGrow: 1,
    backgroundColor: '#E3EFFE',
  },
  filter: {
    maxWidth: 397
  }
}));

export default function MainPage() {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Job Board - Headz.io</title>
        <link rel="canonical" href="https://jobs.headz.io/" />
        <meta name="description" content="Job Board - Headz.io" />
      </Helmet>
      <BrowserView>
        <Container className={classes.root} maxWidth={false} disableGutters>
          <Grid
            container
            direction="row"
            height="100%"
          >
            <Grid item xs={3}>
              <FilterMenu />
            </Grid>
            <Grid item xs={9}>
              <Box>
                <SearchResult />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </BrowserView>
      <MobileView>
        <Container fixed className={classes.root} maxWidth={false}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <Grid item xs={12}>
              <FilterMenu />
            </Grid>


          </Grid>
        </Container>
      </MobileView>
    </>
  );
}




